<template>
  <div class="main-toolbar">
    <md-toolbar>
      <header class="col-sm-12">
        <div class="text-left">
          <h1>{{boxPlaceName}}</h1>
        </div>
        <div class="text-right">
          <md-button class="md-icon-button" @click="showWorkerCommentDialog" v-if="hasMaintenancne">
            <md-icon class="fa fa-pencil"></md-icon>
          </md-button>
          <md-button class="md-icon-button" @click="showReportDialog" v-if="hasMaintenancne">
            <md-icon class="fa fa-file"></md-icon>
          </md-button>
          <md-button class="md-icon-button" @click="showSidePanel" v-if="this.$route.name !== 'SignIn'">
            <md-icon class="fa fa-bars"></md-icon>
          </md-button>
        </div>
      </header>
    </md-toolbar>
    <template  v-if="showMaintenanceInformation">
      <div class="md-layout maintenance-information">
        <p class="md-layout-item md-size-50 maintenance-type">{{maintenanceType}}</p>
        <p class="md-layout-item md-size-50 recall-date">回収日: {{recallDate || ' ー '}}</p>
      </div>
    </template>
    <template v-if="hasHeaderImage">
      <img :src="imgSrc[`${imageName}_${routeType}`]" alt="" class="text-center" />
    </template>
  </div>
</template>

<script>
  import startCheck_1 from '../../assets/img/track/1/start-check.png';
  import normalTemperatureCount_1 from '../../assets/img/track/1/normal-temperature-count.png';
  import normalTemperatureDelivery_1 from '../../assets/img/track/1/normal-temperature-delivery.png';
  import refrigeratedCount_1 from '../../assets/img/track/1/refrigerated-count.png';
  import refrigeratedDelivery_1 from '../../assets/img/track/1/refrigerated-delivery.png';
  import finalCheck_1 from '../../assets/img/track/1/final-check.png';
  import startCheck_2 from '../../assets/img/track/2/start-check.png';
  import normalTemperatureCount_2 from '../../assets/img/track/2/normal-temperature-count.png';
  import normalTemperatureDelivery_2 from '../../assets/img/track/2/normal-temperature-delivery.png';
  import refrigeratedCount_2 from '../../assets/img/track/2/refrigerated-count.png';
  import refrigeratedDelivery_2 from '../../assets/img/track/2/refrigerated-delivery.png';
  import finalCheck_2 from '../../assets/img/track/2/final-check.png';
  import { mapGetters } from 'vuex'

  export default {
    name: 'MainHeader',
    props: {
      title: String,
      imageName: String,
      hasMaintenancne: Boolean,
      showMaintenanceInformation: Boolean,
    },
    computed: {
      ...mapGetters([
        'maintenanceType',
        'recallDate',
      ]),
      boxPlaceName() {
        return this.title === '' ? this.$parent.$store.getters.boxPlaceName : this.title;
      },
      hasHeaderImage() { return this.imageName !== ''; },
      routeType() { return this.$store.getters.routeType; },
    },
    data() {
      return {
        imgSrc: {
          startCheck_1: startCheck_1,
          normalTemperatureCount_1: normalTemperatureCount_1,
          normalTemperatureDelivery_1: normalTemperatureDelivery_1,
          refrigeratedCount_1: refrigeratedCount_1,
          refrigeratedDelivery_1: refrigeratedDelivery_1,
          finalCheck_1: finalCheck_1,
          startCheck_2: startCheck_2,
          normalTemperatureCount_2: normalTemperatureCount_2,
          normalTemperatureDelivery_2: normalTemperatureDelivery_2,
          refrigeratedCount_2: refrigeratedCount_2,
          refrigeratedDelivery_2: refrigeratedDelivery_2,
          finalCheck_2: finalCheck_2,
        }
      };
    },
    methods: {
      showWorkerCommentDialog() {
        this.$emit('showWorkerCommentDialog');
      },
      showReportDialog() {
        this.$emit('showReportDialog');
      },
      showSidePanel() {
        this.$emit('showSidePanel')
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main-toolbar > .md-toolbar {
    background: #fafafa;

    header {
      display: table;

      > div {
        display: table-cell;
        vertical-align: middle;
      }
    }

    h1 {
      font-weight: normal;
      font-size: 1.2rem;
      margin-bottom: 0;
    }
  }

  .maintenance-information {
    padding-top: 0.5rem;
    .maintenance-type {
      padding-left: 1rem;
      text-align: left;
      margin-bottom: 0;
    }

    .recall-date {
      padding-right: 1rem;
      text-align: right;
      margin-bottom: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/globals/MainHeader.vue?0b82f8e7